import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ProtectedRoute, AdminRoute, InternalRoute } from './components/ProtectedRoute';
import './i18n';

const ProfilePage = lazy(() => import('./pages/ProfilePage'));
const LoginPage      = lazy(() => import('./pages/LoginPage'));
const BrowsePage     = lazy(() => import('./pages/BrowsePage'));
const VideoPage      = lazy(() => import('./pages/VideoPage'));
const AdminDashboard = lazy(() => import('./pages/admin/AdminDashboard'));
const VideosList     = lazy(() => import('./pages/admin/VideosList'));
const VideoUpload    = lazy(() => import('./pages/admin/VideoUpload'));
const VideoEdit = lazy(() => import('./pages/admin/VideoEdit'));
const SpeakerEdit     = lazy(() => import('./pages/admin/SpeakerEdit'));
const VideoFiles     = lazy(() => import('./pages/admin/VideoFiles'));
const CategoriesManager = lazy(() => import('./pages/admin/CategoriesManager'));
const SpeakersManager   = lazy(() => import('./pages/admin/SpeakersManager'));
const UsersList      = lazy(() => import('./pages/admin/UsersList'));
const UserImport   = lazy(() => import('./pages/admin/UserImport'));
const AnalyticsPage      = lazy(() => import('./pages/admin/AnalyticsPage'));
const CourseTypesManager = lazy(() => import('./pages/admin/CourseTypesManager'));
const CoursesManager = lazy(() => import('./pages/admin/CoursesManager'));
const CourseEdit     = lazy(() => import('./pages/admin/CourseEdit'));
const CoursePage     = lazy(() => import('./pages/CoursePage'));
const InternalPage      = lazy(() => import('./pages/InternalPage'));
const RegisterPage    = lazy(() => import('./pages/RegisterPage'));
const RegistrationsList = lazy(() => import('./pages/admin/RegistrationsList'));
const ForgotPassword  = lazy(() => import('./pages/ForgotPassword'));
const ResetPassword   = lazy(() => import('./pages/ResetPassword'));
const InternalPostPage  = lazy(() => import('./pages/InternalPostPage'));
const InternalManager   = lazy(() => import('./pages/admin/InternalManager'));
const InternalPostEdit  = lazy(() => import('./pages/admin/InternalPostEdit'));
const LegalPage = lazy(() => import('./pages/LegalPage'));

function LoadingScreen() {
  return <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#060d1a', color: '#4A7B9D', fontFamily: 'sans-serif' }}>Laden...</div>;
}

export default function App() {
  return (
    <Router>
      <Suspense fallback={<LoadingScreen />}>
        <Routes>
          <Route path="/profile" element={<ProtectedRoute><ProfilePage /></ProtectedRoute>} />
          <Route path="/login" element={<LoginPage />} />
        <Route path="/registrieren" element={<RegisterPage />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/impressum" element={<LegalPage seite="impressum" />} />
        <Route path="/datenschutz" element={<LegalPage seite="datenschutz" />} />
          <Route path="/" element={<ProtectedRoute><BrowsePage /></ProtectedRoute>} />
          <Route path="/video/:id" element={<ProtectedRoute><VideoPage /></ProtectedRoute>} />
          <Route path="/admin" element={<AdminRoute><AdminDashboard /></AdminRoute>} />
          <Route path="/admin/videos" element={<AdminRoute><VideosList /></AdminRoute>} />
          <Route path="/admin/videos/upload" element={<AdminRoute><VideoUpload /></AdminRoute>} />
          <Route path="/admin/videos/:id/edit" element={<AdminRoute><VideoEdit /></AdminRoute>} />
        <Route path="/admin/speakers/:id/edit" element={<AdminRoute><SpeakerEdit /></AdminRoute>} />
          <Route path="/admin/videos/:id/files" element={<AdminRoute><VideoFiles /></AdminRoute>} />
          <Route path="/admin/categories" element={<AdminRoute><CategoriesManager /></AdminRoute>} />
          <Route path="/admin/speakers" element={<AdminRoute><SpeakersManager /></AdminRoute>} />
          <Route path="/admin/registrierungen" element={<AdminRoute><RegistrationsList /></AdminRoute>} />
          <Route path="/admin/users" element={<AdminRoute><UsersList /></AdminRoute>} />
              <Route path="/admin/users/import" element={<AdminRoute><UserImport /></AdminRoute>} />
          <Route path="/admin/analytics" element={<AdminRoute><AnalyticsPage /></AdminRoute>} />
          <Route path="/admin/course-types" element={<AdminRoute><CourseTypesManager /></AdminRoute>} />
          <Route path="/admin/courses" element={<AdminRoute><CoursesManager /></AdminRoute>} />
          <Route path="/admin/courses/:id/edit" element={<AdminRoute><CourseEdit /></AdminRoute>} />
          <Route path="/course/:id" element={<ProtectedRoute><CoursePage /></ProtectedRoute>} />
          <Route path="/intern" element={<InternalRoute><InternalPage /></InternalRoute>} />
          <Route path="/intern/:id" element={<InternalRoute><InternalPostPage /></InternalRoute>} />
          <Route path="/admin/internal" element={<AdminRoute><InternalManager /></AdminRoute>} />
          <Route path="/admin/internal/:id/edit" element={<AdminRoute><InternalPostEdit /></AdminRoute>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Suspense>
    </Router>
  );
}
